export default __webpack_public_path__ + "static/tofuLogo-16c945cc325a062c4e4670afb7ad5198.png";